import { Dictionary } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Selector } from '@ngrx/store';

import { IReckonInRoomCredentials } from '@era/locations-sdk';

import * as fromReducer from './in-room-credentials.reducer';
import * as fromState from './in-room-credentials.state';

import { LocationsRouterStoreSelectors } from '../router';

export const selectInRoomCredentialsState: Selector<object, fromState.InRoomCredentialsState> =
  createFeatureSelector<fromState.InRoomCredentialsState>('inRoomCredentials');

export const selectInRoomCredentialsIds: Selector<object, string[] | number[]> = createSelector(
  selectInRoomCredentialsState,
  fromReducer.selectInRoomCredentialsIds
);

export const selectInRoomCredentialsEntities: Selector<object, Dictionary<IReckonInRoomCredentials>> = createSelector(
  selectInRoomCredentialsState,
  fromReducer.selectInRoomCredentialsEntities
);

export const selectAllInRoomCredentials: Selector<object, IReckonInRoomCredentials[]> = createSelector(
  selectInRoomCredentialsState,
  fromReducer.selectAllInRoomCredentials
);

export const selectCurrentInRoomCredentials: Selector<object, IReckonInRoomCredentials> = createSelector(
  LocationsRouterStoreSelectors.selectInRoomCredentialsId,
  selectAllInRoomCredentials,
  (credentialId, credentials) => credentials.find((x) => x.displayId === credentialId)
);

export const selectAllInRoomCredentialsLoaded: Selector<object, boolean> = createSelector(
  selectAllInRoomCredentials,
  (credentials) => credentials && credentials.length > 0
);
